import axios from "axios";
import RefreshTokenHandler from "../refreshToken/refreshToken";
import Config from "../config";

export const getChatbotChat = async (email, clinic_code, patient_id) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/ai-chat/patient-id?email=${email}&clinic_code=${clinic_code}&patient_id=${patient_id}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getChatbotChat(email, clinic_code, patient_id);
      } else {
        throw err.response;
      }
    } else {
      throw err.response;
    }
  }
};

export const getChatbotMessagesPaginated = async (
  email,
  chat_id,
  page_number
) => {
  try {
    const token = sessionStorage.getItem("token");
    // const url = `${Config.baseUrl}/ai-chat/messages/paginate?email=${email}&chat_id=${chat_id}&page_number=${page_number}`;
    const url = `${Config.baseUrl}/ai-chat/messages/paginate?email=${email}&chat_id=${chat_id}&page_number=${page_number}&page_size=5`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getChatbotMessagesPaginated(email, chat_id);
      } else {
        throw err.response;
      }
    } else {
      throw err.response;
    }
  }
};

export const createNewChat = async (
  email,
  distributor_code,
  clinic_code,
  patient_id,
  company_code,
  chat_start_date,
  chat_start_time,
  chat_close_date,
  chat_close_time,
  status,
  has_unread_messages_patient,
  current_status,
  distributor_name,
  clinic_name,
  company_name,
  patient_name
) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/ai-chat/`;
    const result = await axios.post(
      url,
      {
        email,
        distributor_code,
        clinic_code,
        patient_id,
        company_code,
        chat_start_date,
        chat_start_time,
        chat_close_date,
        chat_close_time,
        status,
        has_unread_messages_patient,
        current_status,
        distributor_name,
        clinic_name,
        company_name,
        patient_name,
      },
      {
        headers: {
          Authorization: token || "",
        },
      }
    );
    return result;
  } catch (err) {
    throw err;
  }
};

export const sendChatBotMessage = async (
  email,
  chat_id,
  distributor_code,
  clinic_code,
  company_code,
  patient_id,
  message_send_date,
  status,
  sender_id,
  receiver_id,
  message_content,
  attachment,
  time,
  date,
  sender_email,
  receiver_email,
  sender_name,
  receiver_name,
  action,
  action_performed,
  read_by_patient,
  read_by_patient_email,
  read_by_patient_time,
  sent_by
) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/ai-chat/message`;
    const result = await axios.post(
      url,
      {
        email,
        chat_id,
        distributor_code,
        clinic_code,
        company_code,
        patient_id,
        message_send_date,
        status,
        sender_id,
        receiver_id,
        message_content,
        attachment,
        time,
        date,
        sender_email,
        receiver_email,
        sender_name,
        receiver_name,
        action,
        action_performed,
        read_by_patient,
        read_by_patient_email,
        read_by_patient_time,
        sent_by,
      },
      {
        headers: {
          Authorization: token || "",
        },
      }
    );
    return result;
  } catch (err) {
    throw err;
  }
};
